export default {
    accountOrPasswordError: "အကောင့်အမည် သို့မဟုတ် စကားဝှက်သည် အမှားအယွင်းဖြစ်သည်။",
    noAuth: "လက်ရှိတွင် ခွင့်ပြုချက်မရှိပါ၊ ကျေးဇူးပြု၍ ဖောက်သည်ဝန်ဆောင်မှုဝန်ထမ်းများထံ ဆက်သွယ်ပါ။"
}